<link
  href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap"
  rel="stylesheet"
/>

<div class="grid grid-cols-12 h-[100%]">
  <div class="col-span-12">
    <form
      (keydown)="preventSubmit($event)"
      [formGroup]="form"
      class="h-[100%] flex flex-col justify-between"
    >
      <!-- location -->
      <div id="section-project-location" class="mb-8">
        <div class="sticky top-0 !p-0">
          <div class="flex justify- items-center gap-8 !bg-[#dee2e6] p-4">
            <div
              class="flex justify-start items-center gap-8 top-0 !bg-[#dee2e6]"
            >
              <h3 class="project-brief">Project Brief</h3>
              <span
                class="!ml-[10px] bg-[#F4F4F4] px-[20px] rounded-[0.625rem] text-[#343A40] roboto font-semibold"
                >Location & Site Conditions</span
              >
            </div>
            <!-- Close Icon -->
            <div
              style="position: absolute; top: 10px; right: 36px; z-index: 50"
              (click)="closeDialog()"
            >
              <img
                src="assets/icons/cross-icon.svg"
                alt="cross icon"
                class="cursor-pointer !fixed"
              />
            </div>
          </div>
          <div class="flex justify-end">
            <app-progress-bar
              [progress]="stage1Progress"
              [sectionId]="'section1'"
              [selectedSection]="selectedSection"
              [sectionName]="'Project Brief'"
            >
            </app-progress-bar>
          </div>
        </div>
        <div class="pt-[6px] pr-6 pb-6 pl-6 mx-[10px]">
          <div class="flex" style="align-items: anchor-center">
            <div class="w-1/2">
              <div class="flex w-[100%]">
                <app-country
                  class="w-[100%]"
                  [country]="countryFromMap"
                  [isRequired]="countryRequired"
                  (changeCountry)="updateCountry($event)"
                ></app-country>
              </div>
              <mat-error *ngIf="countryRequired" class="!mb-[10px]">
                Country is required
              </mat-error>
              <div class="flex">
                <div class="relative flex items-center">
                  <mat-form-field
                    class="mt-1 block sm:text-sm"
                    appearance="outline"
                  >
                    <mat-label> City </mat-label>
                    <input matInput formControlName="city" placeholder="City" />
                  </mat-form-field>
                </div>
              </div>

              <div class="flex">
                <div class="relative flex items-center">
                  <mat-form-field
                    class="mt-1 block sm:text-sm"
                    appearance="outline"
                  >
                    <mat-label> Street </mat-label>
                    <input
                      id="Street"
                      matInput
                      formControlName="street"
                      placeholder="Enter Street"
                    />
                  </mat-form-field>
                </div>
              </div>

              <div class="flex">
                <div class="relative flex items-center">
                  <mat-form-field
                    class="mt-1 block sm:text-sm"
                    appearance="outline"
                  >
                    <mat-label> Post Code </mat-label>
                    <input
                      matInput
                      formControlName="zipCode"
                      placeholder="Enter Post Code"
                      (keydown.enter)="getZipCodeData()"
                    />
                  </mat-form-field>
                </div>
              </div>

              <div class="flex">
                <div class="relative flex items-center">
                  <mat-form-field
                    class="mt-1 block sm:text-sm"
                    appearance="outline"
                  >
                    <mat-label> Latitude </mat-label>
                    <input
                      matInput
                      formControlName="latitude"
                      placeholder="Enter Latitude"
                    />
                  </mat-form-field>
                </div>
              </div>

              <div class="flex">
                <div class="relative flex items-center">
                  <mat-form-field
                    class="mt-1 block sm:text-sm"
                    appearance="outline"
                  >
                    <mat-label> Longitude </mat-label>
                    <input
                      matInput
                      formControlName="longitude"
                      placeholder="Enter Longitude"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Image Section -->
            <div
              class="flex justify-end pl-6 w-[100%] h-[400px]"
              style="position: relative"
            >
              <app-search-location
                class="w-[100%]"
                (contentChange)="addMapsStats($event)"
                [latitude]="form.get('latitude')?.value"
                [longitude]="form.get('longitude')?.value"
              ></app-search-location>
            </div>
          </div>
          <!-- upload Site images -->
          <div id="section-project-siteimages" class="mb-4">
            <label for="contractFile" class="block file_label mb-[0.625rem]"
              >Upload Site Images
            </label>

            <div class="flex flex-col items-start">
              <div class="bg-[#f7f6fb] w-[100%]">
                <div
                  class="flex h-[122px] flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 hover:bg-orange-500 hover:bg-opacity-10"
                  (dragover)="onDragOver($event)"
                  (dragleave)="onDragLeave($event)"
                  (drop)="onDrop($event, false)"
                  [class.bg-blue-50]="isDragging"
                >
                  <button
                    type="button"
                    class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded mt-[25px] hover:bg-[#D9D9D9] focus:outline-none"
                    (click)="fileInputDocument.click()"
                  >
                    Attach File
                  </button>
                  <p class="text-lg font-normal text-[#21252A]">Drag & Drop</p>
                  <input
                    type="file"
                    #fileInputDocument
                    (change)="onFileUpload($event, false)"
                    multiple
                    hidden
                  />
                </div>
              </div>
              <div class="flex flex-col">
                <div
                  *ngFor="let file of uploadedFiles; let i = index"
                  class="flex items-start mt-[11px]"
                >
                  <div class="flex justify-start items-center">
                    <div
                      class="relative ml-[5px] !mt-[3px] w-[1.5rem] h-[1.5rem] overflow-hidden"
                    >
                      <img
                        [src]="getFileIcon(file)"
                        alt="File Preview"
                        class="object-cover w-auto h-[100%] cursor-pointer"
                      />
                    </div>
                  </div>
                  <span
                    style="
                      color: black;
                      text-align: left;
                      font-size: 18px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      display: inline-block;
                      overflow: visible;
                      margin-left: 10px;
                      margin-top: 5px;
                    "
                  >
                    {{ file.name }}
                  </span>

                  <img
                    (click)="removeFile(i, file)"
                    src="assets/icons/trash.svg"
                    alt="trash"
                    class="object-cover w-auto h-[17px] cursor-pointer ml-[8px] mt-[8px]"
                  />
                </div>
              </div>
            </div>
            <p *ngIf="fileErrorMessage" class="text-red-500 text-sm mt-2">
              {{ fileErrorMessage }}
            </p>
          </div>
          <!-- Image Preview Modal -->
          <div
            *ngIf="selectedImage !== null"
            class="fixed top-2 left-[31vw] flex flex-col items-center justify-center z-50 h-[100%] w-[100%]"
          >
            <div
              class="bg-[#bcbcd5] rounded-lg p-4 relative w-full h-full flex flex-col justify-center items-center"
              style="background-color: rgba(51, 51, 53, 0.8)"
            >
              <!-- Previous Button -->
              <button
                type="button"
                *ngIf="currentImageIndex > 0"
                (click)="prevImage()"
                class="absolute left-4 top-[50%] bg-gray-300 text-dark p-5"
                title="Previous"
              >
                <span style="font-size: 38px">‹</span>
              </button>

              <!-- Image Display -->
              <img
                *ngIf="projectId"
                [src]="base_path + uploadedFiles[currentImageIndex].preview"
                alt="Preview"
                class="object-scale-down w-100 h-[90vh] items-center"
              />
              <img
                *ngIf="!projectId"
                [src]="uploadedFiles[currentImageIndex].preview"
                alt="Preview"
                class="object-scale-down w-100 h-[90vh] items-center"
              />

              <!-- Next Button -->
              <button
                type="button"
                *ngIf="currentImageIndex < uploadedFiles.length - 1"
                (click)="nextImage()"
                class="absolute right-4 top-[50%] bg-gray-300 text-dark p-5"
                title="Next"
              >
                <span style="font-size: 38px">›</span>
              </button>

              <!-- Close Button -->
              <button
                type="button"
                (click)="closePreview()"
                class="absolute top-2 right-2 bg-red-500 text-white rounded-full w-[31px] h-[31px] flex justify-center items-center p-2 hover:bg-red-600"
                title="Close Preview"
              >
                ✕
              </button>

              <!-- Thumbnails -->
              <div class="flex flex-wrap justify-center mt-4">
                <div
                  *ngFor="let file of uploadedFiles; let i = index"
                  class="relative mx-2 w-16 h-16 border border-gray-300 rounded-md overflow-hidden cursor-pointer"
                  (click)="openPreview(i)"
                >
                  <!-- <ng-container *ngIf="isImageFile(file); else pdfIconThumb"> -->
                  <img
                    [src]="
                      projectId ? base_path + file?.preview : file?.preview
                    "
                    alt="Thumbnail"
                    class="object-cover w-full h-full"
                  />
                  <!-- </ng-container> -->

                  <ng-template #pdfIconThumb>
                    <img
                      src="assets/images/pdf-icon.png"
                      alt="PDF Thumbnail"
                      class="object-cover w-full h-full"
                    />
                  </ng-template>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-4">
            <app-rich-textEditor
              (contentChange)="addProjectSiteCondition($event)"
              [resetEditor]="resetRichTextEditor"
              [richTextValue]="form.get('siteconditions')?.value"
              [placeHolder]="'Site Specific Conditions'"
              [label]="'Site Specific Conditions'"
            ></app-rich-textEditor>
          </div>
          <!-- Upload Documents -->
          <div class="mb-4">
            <label
              for="contractFile"
              class="block file_label !text-[15px] !font-medium mb-[0.625rem]"
              >Upload Documents
            </label>

            <div class="flex flex-col items-start">
              <div class="bg-[#f7f6fb] w-[100%]">
                <div
                  class="flex h-[122px] flex-col items-center justify-center p-6 border-2 border-dashed hover:bg-orange-500 hover:bg-opacity-10 border-gray-300 cursor-pointer transition-all duration-300"
                  (dragover)="onDragOver($event)"
                  (dragleave)="onDragLeave($event)"
                  (drop)="onDrop($event, true)"
                  [class.bg-blue-50]="isDragging"
                >
                  <button
                    type="button"
                    class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded mt-[25px] hover:bg-[#D9D9D9] focus:outline-none"
                    (click)="fileInputImage.click()"
                  >
                    Attach File
                  </button>
                  <input
                    type="file"
                    #fileInputImage
                    (change)="onFileUpload($event, true, false)"
                    multiple
                    hidden
                  />
                  <p class="text-lg font-normal text-[#21252A]">Drag & Drop</p>
                </div>
              </div>
              <div class="flex flex-col">
                <div
                  *ngFor="let file of uploadedLocationFiles; let i = index"
                  class="flex items-start mt-[11px]"
                >
                  <div class="flex justify-start items-center">
                    <div
                      class="relative ml-[5px] w-[1.5rem] h-[1.5rem] overflow-hidden"
                    >
                      <img
                        (click)="openLocationPreview(i)"
                        [src]="getFileIcon(file)"
                        alt="File Preview"
                        class="object-cover w-auto h-[100%] cursor-pointer"
                      />
                    </div>
                  </div>
                  <span
                    style="
                      color: black;
                      text-align: left;
                      font-size: 18px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      display: inline-block;
                      overflow: visible;
                      margin-left: 10px;
                      margin-top: 5px;
                    "
                  >
                    {{ file.name }}
                  </span>

                  <img
                    (click)="removeLocationFile(i, file)"
                    src="assets/icons/trash.svg"
                    alt="trash"
                    class="object-cover w-auto h-[17px] cursor-pointer ml-[8px] mt-[8px]"
                  />
                </div>
              </div>
            </div>
          </div>
          <p *ngIf="locationErrorMessage" class="text-red-500 text-sm mt-2">
            {{ locationErrorMessage }}
          </p>
          <div *ngIf="showFileError" class="text-red-500 text-sm mt-2">
            File is required.
          </div>

          <!-- Image Preview Modal -->
          <div
            *ngIf="selectedLocationImage !== null"
            class="fixed top-2 left-[31vw] flex flex-col items-center justify-center z-50 h-[100%] w-[100%]"
          >
            <div
              class="bg-[#bcbcd5] rounded-lg p-4 relative w-full h-full flex flex-col justify-center items-center"
              style="background-color: rgba(51, 51, 53, 0.8)"
            >
              <!-- Previous Button -->
              <button
                type="button"
                *ngIf="currentImageIndex > 0"
                (click)="prevLocationImage()"
                class="absolute left-4 top-[50%] bg-gray-300 text-dark p-5"
                title="Previous"
              >
                <span style="font-size: 38px">‹</span>
              </button>

              <!-- Image Display -->
              <img
                [src]="
                  projectId
                    ? base_path +
                      uploadedLocationFiles[currentImageIndex].preview
                    : uploadedLocationFiles[currentImageIndex].preview
                "
                alt="Preview"
                class="object-scale-down w-100 h-[90vh] items-center"
              />

              <!-- Next Button -->
              <button
                type="button"
                *ngIf="currentImageIndex < uploadedLocationFiles.length - 1"
                (click)="nextLocationImage()"
                class="absolute right-4 top-[50%] bg-gray-300 text-dark p-5"
                title="Next"
              >
                <span style="font-size: 38px">›</span>
              </button>

              <!-- Close Button -->
              <button
                type="button"
                (click)="closeLocationPreview()"
                class="absolute top-2 right-2 bg-red-500 text-white rounded-full w-[31px] h-[31px] flex justify-center items-center p-2 hover:bg-red-600"
                title="Close Preview"
              >
                ✕
              </button>

              <!-- Thumbnails -->
              <div class="flex flex-wrap justify-center mt-4">
                <div
                  *ngFor="let file of uploadedLocationFiles; let i = index"
                  class="relative mx-2 w-16 h-16 border border-gray-300 rounded-md overflow-hidden cursor-pointer"
                  (click)="openLocationPreview(i)"
                >
                  <img
                    [src]="getFileIcon(file)"
                    alt="Thumbnail"
                    class="object-cover w-full h-full"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-end mb-[30px] sticky">
        <button
          (click)="handleBack()"
          type="button"
          class="save-btn mr-[10px] !font-medium"
        >
          Back
        </button>
        <button
          class="save-btn shadow-[0px_4px_4px_rgba(0,0,0,0.25)] !font-medium"
          type="button"
          (click)="handleSubmit('save')"
        >
          <ng-container *ngIf="isLoadingSave; else normalTextSave">
            <div class="spinner"></div>
          </ng-container>
          <ng-template #normalTextSave>Save</ng-template>
        </button>
        <button
          class="next-btn !font-medium"
          type="button"
          (click)="handleSubmit('next')"
          [ngClass]="{ 'loading-btn': isLoadingNext }"
        >
          <ng-container *ngIf="isLoadingNext; else normalTextNext">
            <div class="spinner"></div>
          </ng-container>
          <ng-template #normalTextNext>Next</ng-template>
        </button>
      </div>
    </form>
  </div>
</div>
